import { render, staticRenderFns } from "./CreditOrder.vue?vue&type=template&id=8848280c&"
import script from "./CreditOrder.vue?vue&type=script&lang=js&"
export * from "./CreditOrder.vue?vue&type=script&lang=js&"
import style0 from "./CreditOrder.vue?vue&type=style&index=0&id=8848280c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports